// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

// Services

export interface IGetPingRequest {
}

export interface IGetPingResponse {
    notificationCount: number;
}

export function ping(): Promise<IGetPingResponse> {
    return request(`${SERVICE_DOMAINS.API}/v1/push.ping`, {
        method: 'GET'
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/push.ts